<div class="main-container" *ngIf="isQuestionPopup && !isScnAccess">
    <div class="question-container">
        <div style="display: flex; gap: 20px;">
            <mat-card class="cardWithShadow go-back-btn" (click)="backToCustomFormsList()">
                <tabler-icon name="arrow-left" size="24"></tabler-icon>
            </mat-card>
            <form [formGroup]="updateForm" (ngSubmit)="updateFormName()" class="valdation-form">
                <div class="form-header">
                    <label>{{ 'CUSTOM_FORM' | translate }} / <sup class="required">*</sup></label>
                    <div class="valdaton-error-require">
                        <input class="form-control" formControlName="name" type="text"
                            (keyup)="setValueinFormName($event.target)">
                        <div class="validation-error"
                            *ngIf="updateForm.get('name').invalid && (updateForm.get('name').dirty || updateForm.get('name').touched)">
                            <div *ngIf="updateForm.get('name').errors?.['required']" style="padding-left: 4px;">
                                {{ 'PLEASE_ENTER_FORM_NAME' | translate }}
                            </div>
                            <div *ngIf="updateForm.get('name').errors?.['minlength']">
                                {{ 'FORM_NAME_MUST_BE_AT_LEAST_3_CHARACTERS_LONG' | translate }}
                            </div>
                            <div *ngIf="updateForm.get('name').errors?.['maxlength']">
                                {{ 'FORM_NAME_CANNOT_BE_MORE_THAN_50_CHARACTERS_LONG' | translate }}
                            </div>
                            <div *ngIf="updateForm.get('name').hasError('noWhiteSpaceValidator')">
                                {{ 'SPACE_NOT_ALLOWED_AT_THE_BEGINNING_OF_FORM_NAME' | translate }}
                            </div>
                        </div>
                    </div>
                    <p-button *ngIf="isInputChanged" class="ml-2" icon="pi pi-check"
                        styleClass="p-button-sm p-button-secondary" [style]="{padding: '7px 3px', marginLeft:'10px'}"
                        (click)="updateFormName()" [disabled]="isFormNameSubmitting" pTooltip="Update Form Name"
                        [loading]="isFormNameSubmitting">
                    </p-button>
                </div>
            </form>
        </div>


        <div class="cards-container">
            <mat-card class="cardWithShadow" style="min-width: 300px;">
                <mat-card-header
                    style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
                    <mat-card-title>{{ 'CONTENT' | translate }}</mat-card-title>
                    <button icon="pi pi-plus" mat-raised-button color="primary" (click)="showTypeModal()"
                        pTooltip="{{ 'ADD_NEW_QUESTION' | translate }}">
                        <i class="pi pi-plus"></i></button>
                </mat-card-header>
                <mat-card-content>

                    <div class="flex justify-content-center content-left-box">
                        <ul>
                            <li class="d-flex align-items-center justify-content-between gap-2"
                                *ngFor="let selectedQuestion of questionsList; let queIndex = index">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span (click)="setSelectedQuestionIndex(queIndex, selectedQuestion)"
                                        class="icon-box me-2" style="margin-right: 5px;"
                                        [ngStyle]="{backgroundColor: questionIcons[selectedQuestion.type].color}">
                                        <i *ngIf="currentStep === queIndex" class="fa fa-check"></i>
                                    </span>
                                    <span class="w-100 content-text" style="word-break: break-all;"
                                        (click)="setSelectedQuestionIndex(queIndex, selectedQuestion)"
                                        [matTooltip]="selectedQuestion.title">
                                        {{ queIndex + 1 }}
                                        {{ selectedQuestion?.title?.length > 30 ? (selectedQuestion?.title | slice: 0 :
                                        30)
                                        + '...' : selectedQuestion?.title }}
                                    </span>
                                </div>
                                <!-- Disable the entire button if there is only one question left -->
                                <button mat-raised-button color="primary" type="button"
                                    [disabled]="questionsList.length === 1" (click)="removeItem(queIndex)">
                                    <i class="pi pi-times"></i>
                                </button>
                            </li>
                        </ul>
                    </div>


                    <span class="no-data-available" *ngIf="questionsList.length === 0"> {{ 'NO_DATA_AVAILABLE' |
                        translate }} </span>
                </mat-card-content>

            </mat-card>
            <mat-card class="cardWithShadow central-card">
                <mat-card-content>
                    <div class="mb-3 header d-flex w-100 close-button-form"
                        [ngClass]="{'justify-content-end': questionsControls.length === 0, 'justify-content-between' : questionsControls.length !== 0 }">
                        <span class="back-button" (click)="backQuestion()" *ngIf="currentStep > 0">
                            < {{ 'BACK' | translate }}</span>
                                <i class="fa fa-times" aria-hidden="true" (click)="closePopup()"></i>
                    </div>


                    <form [formGroup]="questionForm" class="w-100">
                        <!-- <form [formGroup]="questionForm"> -->

                        <!-- <ng-container>
                            <div class="form-group">
                                <label for="name" class="mb-3"> Form Name<sup class="required">*</sup></label>
                                <div class="row">
                                    <mat-form-field class="border-line">
                                        <input matInput placeholder="Enter form name" class="custom-input" formControlName="name" required>
                                    </mat-form-field>
                                </div>
                                <div class="required-error"
                                    *ngIf="questionForm.get('name').invalid && (questionForm.get('name').dirty || questionForm.get('name').touched)">
                                    <div *ngIf="questionForm.get('name').errors?.['required']">
                                        Please enter form name.
                                    </div>
                                </div>
                            </div>
                            <div class="form-check mb-3" *ngIf="UserService.user.role === 'ROLE_CUSTOMER'">
                                <input class="form-check-input" formControlName="scanAccess" type="checkbox" value="" id="scanAccess">
                                <label class="form-check-label" for="scanAccess">
                                    If 3D scan access is required please check
                                </label>
                            </div>
                        </ng-container> -->

                        <ng-container formArrayName="questions"
                            *ngFor="let item of questionsControls.controls; let i = index; let lastIndex = last">
                            <ng-container *ngIf="currentStep === i">
                                <div class="questionHeader">
                                    <h4>{{ 'QUESTION' | translate }} {{i + 1}}</h4>
                                    <div class="closeQuestion" *ngIf="i !== 0">

                                    </div>
                                </div>
                            </ng-container>

                            <ng-container [formGroupName]="i">
                                <div *ngIf="currentStep === i">
                                    <div class="form-group">

                                        <label for="name" class="mb-3">{{ 'TITLE' | translate }}<sup
                                                class="required">*</sup></label>
                                        <!-- <input type="name" class="form-control" formControlName="title"
                                            placeholder="Enter title"> -->
                                        <div class="row">
                                            <mat-form-field class="border-line">
                                                <!-- <mat-label>Title</mat-label> -->
                                                <input matInput placeholder="{{ 'ENTER_TITLE' | translate }}"
                                                    (input)="changeTitle(i, $event)" class="custom-input"
                                                    formControlName="title" required>
                                            </mat-form-field>
                                        </div>
                                        <!-- <div class="required-error"
                                            *ngIf="item.controls.title.invalid && (item.controls.title.dirty || item.controls.title.touched)">
                                            <div *ngIf="item.controls.title.errors?.['required']">
                                                Please enter title.
                                            </div>
                                        </div> -->

                                        <div class="required-error"
                                            *ngIf="item.get('title').hasError('noWhiteSpaceValidator')">
                                            Space not allowed at the beginning of the title.
                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label for="description" class="mb-3">{{ 'SUBTITLE' | translate }}</label>
                                        <!-- <input type="description" class="form-control" formControlName="subtitle"
                                            placeholder="Enter subtitle"> -->
                                        <div class="row">
                                            <mat-form-field class="border-line">
                                                <!-- <mat-label>Sub Title</mat-label> -->
                                                <input matInput placeholder="{{ 'ENTER_SUBTITLE' | translate }}"
                                                    (input)="changeSubTitle(i, $event)" class="custom-input"
                                                    formControlName="subtitle">
                                            </mat-form-field>
                                        </div>
                                        <!-- <div class="required-error"
                                            *ngIf="item.controls.subtitle.invalid && (item.controls.subtitle.dirty || item.controls.subtitle.touched)">
                                            <div *ngIf="item.controls.subtitle.errors?.['required']">
                                                Please enter subtitle.
                                            </div>
                                        </div> -->
                                    </div>

                                    <!-- Question Image Toggle -->
                                    <div class="form-group"
                                        *ngIf="selectedType !== 'multipleChoice' && selectedType !== 'uniqueChoice' && selectedType !== 'customComponents' && selectedType !== 'requiredImages'">
                                        <div class="d-flex align-items-center gap-3 mb-3" style="gap: 10px;">
                                            <p-inputSwitch id="flexSwitch" formControlName="hasImage"
                                                (onChange)="onImageToggleChange(i, $event)">
                                            </p-inputSwitch>
                                            <label for="flexSwitch" class="ml-2">{{ 'ADD_IMAGE_TO_QUESTION' | translate
                                                }}</label>
                                        </div>
                                        <!-- Image Upload Section -->
                                        <div *ngIf="item.get('hasImage')?.value" class="image-upload-section">
                                            <div class="card-header-container" style="max-width: 300px;">
                                                <label>
                                                    <img *ngIf="item.get('image')?.value" class="question-image"
                                                        [src]="item.get('image')?.value" alt="question image"
                                                        style="width: 100%; height: 150px; object-fit: cover; border-radius: 8px;">

                                                    <div *ngIf="!item.get('image')?.value" class="box">
                                                        <span>{{ 'UPLOAD' | translate }}</span>
                                                        <input type="file" #questionFileInput
                                                            (change)="selectQuestionImage($event, item, i)"
                                                            class="form-control" style="display: none;"
                                                            accept="image/*">
                                                    </div>
                                                </label>
                                                <label>
                                                    <div class="box" (click)="openQuestionGallery($event, item, i)">
                                                        <span>{{ 'GALLERY' | translate }}</span>
                                                    </div>
                                                </label>
                                            </div>

                                            <!-- Change Image Button -->
                                            <div *ngIf="item.get('image')?.value" class="mt-2">
                                                <button type="button" class="btn btn-sm btn-outline-primary"
                                                    (click)="changeQuestionImage(item, i)">
                                                    {{ 'CHANGE_IMAGE' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class=""
                                        *ngIf="selectedType === 'dropdown' || selectedType === 'checkbox' || selectedType === 'radio'">
                                        <label for="" class="mb-3">{{ 'OPTIONS_LIST' | translate }}</label>
                                        <div class="dropdown-text">
                                            <p-chips formControlName="options" placeholder="Dropdown"></p-chips>
                                        </div>
                                        <!-- <div class="row">
                                            <mat-form-field class="border-line">
                                                <input matInput placeholder="dropdown" (input)="changeOptionsList(i, $event)"
                                                    class="custom-input" formControlName="options" required>
                                            </mat-form-field>
                                        </div> -->
                                    </div>

                                    <!-- DefaultFocus -->
                                    <div class="mb-3" *ngIf="selectedType === '3dBody'">
                                        <label>DefaultFocus<sup class="required">*</sup></label>
                                        <select formControlName="defaultFocus" class="form-select"
                                            aria-label="Default select example">
                                            <option value="upperBody">upperBody</option>
                                            <option value="lowerBody">lowerBody</option>
                                            <option value="entireBody">entireBody</option>
                                        </select>

                                        <label for="">Annotations</label>
                                        <div class="">
                                            <p-chips formControlName="annotations" placeholder="Annotations"></p-chips>
                                        </div>
                                    </div>

                                    <!-- BEFORE _MULTIPLEDESIGN -->
                                    <!-- multipleChoice -->
                                    <!-- <div class="fileSection" *ngIf="selectedType === 'multipleChoice'">
                                        <ng-container formArrayName="choices" *ngFor="let item of choicesControls(i).controls; let j = index;">
                                            <ng-container [formGroupName]="j">
                                                <div class="form-group">
                                                    <label for="name">Select your file<sup class="required">*</sup></label>
                                                    <div class="input-group">
                                                        <input type="file" (change)="selectImage(item,j)" class="form-control"
                                                            placeholder="select file">
                                                        <span class="input-group-text cursor-pointer" pTooltip="Select from gallery"
                                                            tooltipPosition="top" (click)="showDialog('bottom', item, j)"><i
                                                                class="pi pi-image"></i></span>
                                                    </div>
                                                    <small class="text-success" *ngIf="item?.value?.image">Selected File:
                                                        {{item?.value?.image}}</small>
                                                    <div *ngIf="item.controls.image.invalid && (item.controls.image.dirty || item.controls.image.touched)"
                                                        class="required-error">
                                                        <div *ngIf="item.controls.image.errors?.['required']">
                                                            This field is required.
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="form-group">
                                                    <label for="description">Image Title</label>
                                                    <input type="description" class="form-control" formControlName="title"
                                                        placeholder="Enter your title">
                                                    <div *ngIf="item.controls.title.invalid && (item.controls.title.dirty || item.controls.title.touched)"
                                                        class="required-error">
                                                        <div *ngIf="item.controls.title.errors?.['required']">
                                                            Please enter image title.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="buttonSection">
                                                    <div class="row">
                                                        <ng-container formArrayName="options"
                                                            *ngFor="let item of optionControls(i,j).controls; let k = index;">
                                                            <ng-container [formGroupName]="k">
                                                                <div class="col-md-6">
                                                                    <div class="optionButton">
                                                                        <div class="form-group nameField">
                                                                            <label for="description">Option Name</label>
                                                                            <input type="text" class="form-control" formControlName="name"
                                                                                placeholder="Enter your button name">
                                                                            <div *ngIf="item.controls.name.invalid && (item.controls.name.dirty || item.controls.name.touched)"
                                                                                class="required-error">
                                                                                <div *ngIf="item.controls.name.errors?.['required']">
                                                                                    Please enter option name.
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mt-3">
                                                                            <button class="btn btn-light opt-button" type="button"
                                                                                *ngIf="(currentStep === i) && choicesCurrentInd === j && k === 1 "
                                                                                (click)="removeOption(i,j,k)">
                                                                                remove option
                                                                            </button>
                                                                            <button class="btn btn-light opt-button" type="button"
                                                                                *ngIf="(currentStep === i) && choicesCurrentInd === j && (optionControls(i,j).controls.length <2) && j !== 0"
                                                                                (click)="addOption(i,j,k)">
                                                                                Add Option
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
    
                                                </div>
                                            </ng-container>
                                            <div class="btn-section text-right">
                                                <button class="btn btn-secondary choice-button" (click)="removeChoices(i,j)" type="button"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j) && j !== 0">
                                                    Remove Choice
                                                </button>
    
                                                <button class=" btn btn-secondary choice-button" (click)="addChoices(i,j)" type="button"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j)">
                                                    Add Choice
                                                </button>
                                            </div>
                                        </ng-container>
    
                                    </div> -->

                                    <!-- AFTER _MULTIPLEDESIGN -->
                                    <!-- multipleChoice -->
                                    <div class="multiple-list-main" *ngIf="selectedType === 'multipleChoice'">
                                        <ng-container formArrayName="choices"
                                            *ngFor="let item of choicesControls(i).controls; let j = index;">

                                            <div class="multiple">
                                                <ng-container [formGroupName]="j">
                                                    <!-- <button (click)="removeChoices(i,j)" type="button" class="add-btn close-icon"
                                                        *ngIf="(currentStep === i) && (choicesCurrentInd === j) && j !== 0"> -->
                                                    <button (click)="removeChoices(i,j)" type="button"
                                                        class="add-btn close-icon" *ngIf="j !== 0">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                    <div class="card-header-container">
                                                        <label>
                                                            <img *ngIf="item.value.image" class="uniqueChoice-image"
                                                                [src]="item.value.image" alt="upload">

                                                            <div *ngIf="!item.value.image" class="box">
                                                                <span>{{ 'UPLOAD' | translate }}</span>
                                                                <input type="file"
                                                                    (change)="selectImage($event, item, j)"
                                                                    id="fileInput" class="form-control"
                                                                    style="display: none;">
                                                            </div>
                                                        </label>
                                                        <label>
                                                            <div class="box" (click)="openGallery($event, item, j)">
                                                                <span>{{ 'GALLERY' | translate }}</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="form-group title-input">
                                                        <!-- <label for="description">Image Title</label> -->
                                                        <input type="description" class="form-control"
                                                            formControlName="title" placeholder="Enter your title">
                                                        <div *ngIf="item.get('title').invalid && (item.get('title').dirty || item.get('title').touched)"
                                                            class="required-error">
                                                            <div *ngIf="item.get('title').errors?.['required']">
                                                                {{ 'PLEASE_ENTER_IMAGE_TITLE' | translate }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- buttonSection -->
                                                    <div class="buttonSection">
                                                        <ng-container formArrayName="options"
                                                            *ngFor="let item of optionControls(i,j).controls; let k = index;">
                                                            <ng-container [formGroupName]="k">
                                                                <div class="optionButton">
                                                                    <div class="form-group">
                                                                        <!-- <label for="description">Option Name</label> -->
                                                                        <input type="text" class="form-control"
                                                                            formControlName="name" placeholder="Text">
                                                                        <div *ngIf="item.get('name')?.invalid && (item.get('name')?.dirty || item.get('name')?.touched)"
                                                                            class="required-error">
                                                                            <div
                                                                                *ngIf="item.get('name')?.errors?.['required']">
                                                                                {{ 'PLEASE_ENTER_OPTION_NAME' |
                                                                                translate }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- IF add only choicesCurrentInd   -->
                                                                <!-- <div class="optionButton"
                                                                *ngIf="(currentStep === i) && choicesCurrentInd === j && k === 1 ">
                                                                <button class="btn btn-light opt-button" type="button"
                                                                    (click)="removeOption(i,j,k)">
                                                                    remove option
                                                                </button>
                                                                </div> -->
                                                                <div *ngIf="(currentStep === i) && k === 1 ">
                                                                    <button class="m-l-15" mat-mini-fab color="primary"
                                                                        matTooltip="{{ 'Add' | translate}}"
                                                                        (click)="removeOption(i,j,k)">
                                                                        <mat-icon>remove</mat-icon>
                                                                    </button>
                                                                </div>
                                                                <!-- IF add only choicesCurrentInd   -->
                                                                <!-- <div
                                                                *ngIf="(currentStep === i) && choicesCurrentInd === j && (optionControls(i,j).controls.length <2) && j !== 0">
                                                                <button class="btn btn-light opt-button" type="button"
                                                                    (click)="addOption(i,j,k)">
                                                                    Add Option
                                                                </button>
                                                                </div> -->
                                                                <div
                                                                    *ngIf="(currentStep === i)  && (optionControls(i,j).controls.length <2) ">
                                                                    <button class="m-l-15" mat-mini-fab color="primary"
                                                                        matTooltip="{{ 'Add' | translate}}"
                                                                        (click)="addOption(i,j,k)">
                                                                        <mat-icon>add</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <ng-container [formGroupName]="j">
                                                <div class="multiple cursor-pointer"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j)"
                                                    (click)="addChoices(i,j)">
                                                    <div class="square-image-input">
                                                        <button type="button" class="add-btn">
                                                            <span>{{ 'ADD_CHOICE' | translate }}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>

                                    <!-- requiredImages -->
                                    <div class="multiple-list-main" *ngIf="selectedType === 'requiredImages'">
                                        <ng-container formArrayName="choices"
                                            *ngFor="let item of choicesControls(i).controls; let j = index;">

                                            <div class="multiple">
                                                <ng-container [formGroupName]="j">
                                                    <button (click)="removeChoices(i,j)" type="button"
                                                        class="remove-button close-icon" *ngIf="j !== 0">
                                                        <mat-icon>remove</mat-icon>
                                                    </button>
                                                    <div class="card-header-container">
                                                        <!-- Cuando hay imagen -->
                                                        <div *ngIf="item.value.image" class="image-with-controls">
                                                            <img class="uniqueChoice-image" [src]="item.value.image"
                                                                alt="upload">
                                                            <div class="image-controls">
                                                                <label class="replace-btn">
                                                                    <span>{{ 'REPLACE_IMAGE' | translate }}</span>
                                                                    <input type="file"
                                                                        (change)="selectImage($event, item, j)"
                                                                        class="form-control" style="display: none;"
                                                                        accept="image/*">
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <!-- Cuando no hay imagen -->
                                                        <div *ngIf="!item.value.image" class="upload-controls">
                                                            <label class="box">
                                                                <span>{{ 'UPLOAD_IMAGE' | translate }}</span>
                                                                <input type="file"
                                                                    (change)="selectImage($event, item, j)"
                                                                    class="form-control" style="display: none;"
                                                                    accept="image/*">
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="form-group title-input">
                                                        <input type="text" class="form-control" formControlName="title"
                                                            placeholder="{{ 'ENTER_IMAGE_TITLE' | translate }}">
                                                        <div *ngIf="item.get('title').invalid && (item.get('title').dirty || item.get('title').touched)"
                                                            class="required-error">
                                                            <div *ngIf="item.get('title').errors?.['required']">
                                                                {{ 'PLEASE_ENTER_IMAGE_TITLE' | translate }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <ng-container [formGroupName]="j">
                                                <div class="multiple cursor-pointer"
                                                    *ngIf="(currentStep === i) && (j === choicesControls(i).controls.length - 1)"
                                                    (click)="addChoices(i,j)">
                                                    <div class="square-image-input">
                                                        <button type="button" class="add-btn">
                                                            <span>{{ 'ADD_IMAGE' | translate }}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>

                                    <!-- uniqueChoice -->
                                    <!-- <div class="fileSection" *ngIf="selectedType === 'uniqueChoice'">
                                        <ng-container formArrayName="choices" *ngFor="let item of choicesControls(i).controls; let j = index;">
                                            <ng-container [formGroupName]="j">
                                                <div class="form-group">
                                                    <label for="name">Select your file</label>
                                                    <div class="input-group">
                                                        <input type="file" (change)="selectImage(item,j)" class="form-control"
                                                            placeholder="select file">
                                                        <span class="input-group-text cursor-pointer" pTooltip="Select from gallery"
                                                            tooltipPosition="top" (click)="showDialog('bottom', item, j, 'uniqueChoice' + j)"><i
                                                                class="pi pi-image"></i></span>
                                                    </div>
                                                    <small class="text-success" *ngIf="item?.value?.image">Selected File:
                                                        {{selectedImage ? selectedImage?.path : item?.value?.image}}</small>
                                                    <div *ngIf="item.controls.image.invalid && (item.controls.image.dirty || item.controls.image.touched)"
                                                        class="required-error">
                                                        <div *ngIf="item.controls.image.errors?.['required']">
                                                            This field is required.
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="buttonSection">
                                                    <div class="row">
                                                        <ng-container formArrayName="options"
                                                            *ngFor="let item of optionControls(i,j).controls; let k = index;">
                                                            <ng-container [formGroupName]="k">
                                                                <div class="col-md-6">
                                                                    <div class="optionButton">
                                                                        <div class="form-group nameField">
                                                                            <label for="description">Option Name</label>
                                                                            <input type="text" class="form-control" formControlName="name"
                                                                                placeholder="Enter your button name">
                                                                            <div *ngIf="item.controls.name.invalid && (item.controls.name.dirty || item.controls.name.touched)"
                                                                                class="required-error">
                                                                                <div *ngIf="item.controls.name.errors?.['required']">
                                                                                    Please enter option name.
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
    
                                                </div>
                                            </ng-container>
                                            <div class="btn-section text-right">
                                                <button class="btn btn-secondary choice-button" (click)="removeChoices(i,j)" type="button"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j) && j !== 0">
                                                    Remove Choice
                                                </button>
    
                                                <button class=" btn btn-secondary choice-button" (click)="addChoices(i,j)" type="button"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j)">
                                                    Add Choice
                                                </button>
                                            </div>
                                        </ng-container>
                                    </div> -->

                                    <div class="multiple-list-main" *ngIf="selectedType === 'uniqueChoice'">
                                        <ng-container formArrayName="choices"
                                            *ngFor="let item of choicesControls(i).controls; let j = index;">
                                            <div class="multiple">
                                                <ng-container [formGroupName]="j">
                                                    <button (click)="removeChoices(i,j)" type="button"
                                                        class="add-btn close-icon"
                                                        *ngIf="(currentStep === i) && (choicesCurrentInd === j) && j !== 0">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                    <div class="square-image-input">
                                                        <label>
                                                            <ng-container *ngIf="item.get('image')?.value">
                                                                <img class="uniqueChoice-image"
                                                                    [src]="item.get('image')?.value" alt="">
                                                            </ng-container>
                                                            <ng-container *ngIf="!item.get('image')?.value">
                                                                {{ 'ADD_IMAGE' | translate }}
                                                            </ng-container>
                                                            <input type="file" (change)="selectImage($event,item,j)"
                                                                id="fileInput" class="form-control"
                                                                style="display: none;">

                                                            <span class="input-group-text cursor-pointer"
                                                                pTooltip="{{ 'SELECT_FROM_GALLERY' | translate }}"
                                                                tooltipPosition="top"
                                                                (click)="openGallery($event, item, j)"><i
                                                                    class="pi pi-image"></i></span>
                                                        </label>
                                                    </div>
                                                    <!-- buttonSection -->
                                                    <div class="buttonSection mt-2">
                                                        <ng-container formArrayName="options"
                                                            *ngFor="let item of optionControls(i, j).controls; let k = index;">
                                                            <ng-container [formGroupName]="k">
                                                                <div class="optionButton">
                                                                    <div class="form-group nameField">
                                                                        <input type="text" class="form-control"
                                                                            formControlName="name"
                                                                            placeholder="Enter your button name"
                                                                            style="text-align: center;">

                                                                        <div *ngIf="item.get('name').invalid && (item.get('name').dirty || item.get('name').touched)"
                                                                            class="required-error">
                                                                            <div
                                                                                *ngIf="item.get('name').errors?.['required']">
                                                                                {{ 'PLEASE_ENTER_OPTION_NAME' |
                                                                                translate }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                    <!-- Prescription Template Dropdown -->
                                                    <div class="prescription-template-dropdown mt-2"
                                                        style="width: 100%;"
                                                        *ngIf="requireWeb3DScansControl.value && questionsControls.at(i).get('title')?.value !== 'Gender'">
                                                        <label class="form-label"
                                                            style="font-size: 12px; text-align: center;">{{"PRESCRIPTION_TEMPLATE"
                                                            | translate}} {{"OPTIONAL" | translate}}</label>
                                                        <p-dropdown [options]="prescriptionTemplates"
                                                            formControlName="prescriptionTemplateId" optionLabel="name"
                                                            optionValue="ID" placeholder="Select a template"
                                                            [showClear]="true" [filter]="true" filterBy="name"
                                                            [style]="{'width': '100%'}">
                                                            <ng-template pTemplate="selectedItem" let-template>
                                                                <div *ngIf="template">
                                                                    <span>{{ template.name }}</span>
                                                                </div>
                                                            </ng-template>
                                                            <ng-template pTemplate="item" let-template>
                                                                <div>
                                                                    <div><strong>{{ template.name }}</strong></div>
                                                                    <div style="font-size: 11px; color: #666;"
                                                                        *ngIf="template.description">
                                                                        {{ template.description }}
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                        </p-dropdown>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <ng-container [formGroupName]="j">
                                                <div class="multiple"
                                                    *ngIf="(currentStep === i) && (choicesCurrentInd === j)">

                                                    <div class="square-image-input">
                                                        <button (click)="addChoices(i,j)" type="button" class="add-btn">
                                                            {{ 'ADD_CHOICE' | translate }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>

                                    <!-- customComponents -->
                                    <div class="fileSection" *ngIf="selectedType === 'customComponents'">
                                        <ng-container formArrayName="components"
                                            *ngFor="let item of componentsControls(i).controls; let j=index">
                                            <ng-container [formGroupName]="j">
                                                <app-custom-component [instanceId]="j"
                                                    [customForm]="this.inputCustomForm && this.inputCustomForm.length > j ? this.inputCustomForm[j] : null"></app-custom-component>
                                                <!-- </ng-container> -->
                                                <div class="btn-section text-right mb-3">
                                                    <button class="m-l-15" mat-mini-fab color="primary"
                                                        (click)="removeComponent(i,j)"
                                                        *ngIf="(j === 0 && componentsControls(i).controls.length > 1) || j > 0">
                                                        <mat-icon>remove</mat-icon>
                                                    </button>
                                                    <button class="m-l-15" mat-mini-fab color="primary"
                                                        (click)="addComponent(i,j)">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>

                                    <div *ngIf="selectedType === 'productsList'">
                                        <div class="py-4">
                                            <label>{{ 'SELECT_PRODUCTS' | translate }}</label>
                                            <div class="multi-select">
                                                <p-multiSelect [options]="productList" formControlName="products"
                                                    [showHeader]="false" [style]="{width: '100%'}" [filter]="false"
                                                    optionLabel="name" optionValue="id">
                                                    <ng-template let-item pTemplate="item">
                                                        <div class="option-item">
                                                            <img [src]="item.images[0]" alt="{{ item.name }}"
                                                                class="option-image" />
                                                            <span>{{ item.name }}</span>
                                                        </div>
                                                    </ng-template>

                                                    <ng-template let-item pTemplate="selectedItem">
                                                        <div class="selected-item">
                                                            <img [src]="item.images[0]" alt="{{ item.name }}"
                                                                class="selected-image" />
                                                            <span>{{ item.name }}</span>
                                                        </div>
                                                    </ng-template>
                                                </p-multiSelect>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btn-section text-right">

                                        <!-- Submit -->
                                        <p-button label="{{ 'SUBMIT' | translate }}" icon="pi pi-check" iconPos="right"
                                            styleClass="p-button-sm" (click)="questionSubmit()" type="button"
                                            *ngIf="(lastIndex && !isEdit)"
                                            [disabled]="questionForm.invalid && isSubmitting">
                                        </p-button>
                                        <!-- <button class="btn btn-primary" (click)="questionSubmit(i)" type="button" *ngIf="(currentStep === i && !isEdit)"
                                            [disabled]="questionForm.invalid">
                                            Submit
                                        </button> <button class="btn btn-primary" (click)="questionSubmit(i)" type="button"
                                            *ngIf="(currentStep >= (editedItem?.questions?.length - 1) && isEdit)" [disabled]="questionForm.invalid">
                                            Update
                                        </button> <button class="btn btn-primary" *ngIf="(currentStep === i ) && selectedType !== 'productsList'" type="button"
                                            (click)="nextQuestion(currentStep,i)">
                                            Next
                                        </button> -->
                                    </div>
                                </div>
                            </ng-container>

                        </ng-container>

                        <span class="no-data-available" *ngIf="questionsControls.length === 0"> No data
                            available. </span>
                    </form>
                </mat-card-content>
            </mat-card>

            <mat-card class="cardWithShadow" style="min-width: 300px;">
                <mat-card-content>
                    <div class="container p-0">
                        <label class="p-1" for="">{{ 'TYPE' | translate }}</label>
                        <p-dropdown [options]="questionTypes" (onChange)="setQueType(currentStep)"
                            [(ngModel)]="selectedQueType" [style]="{ 'width': '100%', 'margin-top': '10px' }"
                            placeholder="Type of form">
                            <ng-template pTemplate="selectedItem">
                                <div class="d-flex align-items-center gap-2" *ngIf="selectedQueType">
                                    <span class="icon-box"
                                        [ngStyle]="{backgroundColor: questionIcons[selectedQueType].color}"><i
                                            class="{{questionIcons[selectedQueType].icon}}"></i></span>
                                    <div>{{ 'QUESTION_TYPES.' + selectedQueType | translate }}</div>
                                </div>
                            </ng-template>
                            <ng-template let-type pTemplate="item">
                                <div class="d-flex align-items-center gap-2">
                                    <span class="icon-box" [ngStyle]="{backgroundColor: questionIcons[type].color}"><i
                                            class="{{questionIcons[type].icon}}"></i></span>
                                    <div>{{ 'QUESTION_TYPES.' + type | translate }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <div class="form-check form-switch my-3" style="display: flex; margin-top: 15px; gap: 6px;"
                            *ngIf="requiredControl">
                            <p-inputSwitch id="flexSwitchCheckDefault" [formControl]="requiredControl"
                                (onChange)="changeRequired(currentStep, $event.checked)">
                            </p-inputSwitch>
                            <label for="flexSwitchCheckDefault" class="ml-2">{{ 'REQUIRED' | translate }}</label>
                        </div>
                    </div>
                    <div style="margin-top: 15px;" *ngIf="userService.user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL'">
                        <div>
                            <label class="p-1" for="">{{ 'CLIENTS' | translate }}</label>
                        </div>
                        <!-- <p-multiSelect [options]="clientList" [(ngModel)]="selectedClient" defaultLabel="Select a Client" [showHeader]="false"
                                (onChange)="clientSelected($event)" [filter]="false" optionLabel="name"></p-multiSelect> -->

                        <p-multiSelect class="client-list-dropdown" [options]="clientList"
                            [style]="{ 'width': '100%', 'margin-top': '10px' }" [(ngModel)]="selectedClient"
                            defaultLabel="Select a Client" (onChange)="clientSelected()" optionLabel="name"
                            [showClear]="true" selectedItemsLabel="{0} {{ 'CLIENTS_SELECTED' | translate }}"
                            [maxSelectedLabels]="1">
                        </p-multiSelect>

                    </div>

                    <div class="form-check mb-3" *ngIf="userService.user.role === 'ROLE_CUSTOMER'">
                        <!-- <input class="form-check-input" formControlName="requireScans" type="checkbox" value="" id="scanAccess"
                        (change)="onScanAccessChange($event.target.checked)"> -->
                        <div style="display: flex; margin-top: 15px; gap: 6px;">
                            <p-inputSwitch [formControl]="requireScansControl" id="scanAccess"></p-inputSwitch>
                            <label for="scanAccess" class="ml-2">{{ 'REQUIRE_3D_SCANS' | translate }}</label>
                        </div>

                        <div style="display: flex; margin-top: 15px; gap: 6px;">
                            <p-inputSwitch [formControl]="requireWeb3DScansControl"
                                id="web3DScanAccess"></p-inputSwitch>
                            <label for="web3DScanAccess" class="ml-2">{{ 'REQUIRE_WEB_3D_SCANS' | translate }}</label>
                        </div>

                        <div *ngIf="requireScansControl.value" style="display: flex; margin-top: 15px; gap: 6px;">

                            <p-inputSwitch [formControl]="requireNameControl" id="requiredName"></p-inputSwitch>
                            <label for="requiredName" class="ml-2">{{ 'REQUIRE_NAME' | translate }}</label>

                        </div>

                        <div *ngIf="requireScansControl.value" style="display: flex; margin-top: 15px; gap: 6px;">

                            <p-inputSwitch [formControl]="requireSurnameControl" id="requiredSurname"></p-inputSwitch>
                            <label for="requiredSurname" class="ml-2">{{ 'REQUIRE_SURNAME' | translate }}</label>

                        </div>

                        <div *ngIf="requireScansControl.value" style="display: flex; margin-top: 15px; gap: 6px;">

                            <p-inputSwitch [formControl]="requireShoeSizeControl" id="requiredShoeSize"></p-inputSwitch>
                            <label for="requiredShoeSize" class="ml-2">{{ 'REQUIRE_SHOE_SIZE' | translate }}</label>

                        </div>

                        <div *ngIf="requireScansControl.value" style="display: flex; margin-top: 15px; gap: 6px;">

                            <p-inputSwitch [formControl]="requireVideoControl" id="requiredVideo"></p-inputSwitch>
                            <label for="requiredVideo" class="ml-2">{{ 'REQUIRE_VIDEO' | translate }}</label>

                        </div>

                        <div *ngIf="requireScansControl.value" style="display: flex; margin-top: 15px; gap: 6px;">

                            <p-inputSwitch [formControl]="enableShippingControl" id="enableShipping"></p-inputSwitch>
                            <label for="enableShipping" class="ml-2">{{ 'ENABLE_SHIPPING' | translate }}</label>

                        </div>

                        <div *ngIf="requireScansControl.value" style="margin-top: 15px;">
                            <label class="p-1" for="">{{ 'CLINIC' | translate }}</label>
                        </div>

                        <p-dropdown *ngIf="requireScansControl.value" class="client-list-dropdown" [options]="clinics"
                            [formControl]="clinicIdControl" [style]="{ 'width': '100%', 'margin-top': '10px' }"
                            placeholder="{{ 'SELECT_A_CLINIC' | translate }}" optionLabel="name" optionValue="ID"
                            [showClear]="true" [filter]="true">
                        </p-dropdown>

                        <div *ngIf="requireScansControl.value" style="margin-top: 15px;">
                            <label class="p-1" for="">{{ 'SCANNING_TYPE' | translate }}</label>
                        </div>

                        <p-dropdown *ngIf="requireScansControl.value" class="client-list-dropdown" [options]="scanTypes"
                            [formControl]="scanningTypeControl" [style]="{ 'width': '100%', 'margin-top': '10px' }"
                            placeholder="{{ 'SELECT_A_SCANNING_TYPE' | translate }}" [showClear]="true" [filter]="true">
                        </p-dropdown>
                    </div>

                    <div style="margin-top: 15px;" *ngIf="selectedType === 'uniqueChoice'">
                        <label class="p-1" for="">{{ 'LOGIC' | translate }}</label>

                        <!-- Mostrar reglas existentes -->
                        <div *ngIf="getCurrentQuestionLogic().length > 0"
                            style="margin-top: 10px; margin-bottom: 15px;">
                            <div *ngFor="let rule of getCurrentQuestionLogic(); let i = index"
                                style="background: #f5f5f5; padding: 10px; border-radius: 5px; margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <strong>{{rule.condition}}:</strong> {{rule.selectedOption}} → <strong>{{ 'GO_TO' |
                                        translate }}:</strong> {{ 'QUESTION' | translate }} {{rule.goToIndex + 1}}
                                </div>
                                <button mat-icon-button color="warn" (click)="removeLogicRule(i)" type="button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>

                        <!-- Formulario para agregar nueva regla -->
                        <div style="margin-top: 10px;">
                            <label class="p-1" for="">{{ 'IF_OPTION_IS' | translate }}:</label>
                            <p-dropdown [options]="getChoicesForCurrentQuestion()" [(ngModel)]="selectedLogicOption"
                                [style]="{ 'width': '100%', 'margin-top': '5px' }"
                                placeholder="{{ 'SELECT_OPTION' | translate }}" optionLabel="name" optionValue="name"
                                [showClear]="true">
                            </p-dropdown>
                        </div>

                        <div style="margin-top: 10px;">
                            <label class="p-1" for="">Go to:</label>
                            <p-dropdown [options]="getAvailableQuestions()" [(ngModel)]="selectedGoToQuestion"
                                [style]="{ 'width': '100%', 'margin-top': '5px' }"
                                placeholder="{{ 'SELECT_QUESTION' | translate }}" optionLabel="label"
                                optionValue="index" [showClear]="true">
                            </p-dropdown>
                        </div>

                        <button mat-raised-button color="primary" (click)="updateQuestionLogic()" type="button"
                            style="margin-top: 10px; width: 100%;"
                            [disabled]="!selectedLogicOption || selectedGoToQuestion === null || selectedGoToQuestion === undefined">
                            {{ 'ADD_LOGIC_RULE' | translate }}
                        </button>
                    </div>

                    <div class="update-button-container">
                        <button *ngIf=" isEdit" mat-raised-button color="primary" (click)="questionSubmit()"
                            [disabled]="questionForm.invalid && isSubmitting">
                            {{ 'UPDATE' | translate }}</button>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>

    </div>
</div>

<p-dialog header="Media Gallery" [(visible)]="visible" [position]="position"
    [style]="{ width: '50vw', maxHeight: '400px' }" [draggable]="false" [modal]="true">
    <div class="container">
        <div class="row g-2">
            <ng-container *ngFor="let img of galleryImages">
                <div class="col-md-4">
                    <div class="image-container" [class.selected]="selectedImage?.path === img?.path"
                        (click)="toggleImage(img)">
                        <img class="gallery-img" pTooltip="{{img.name}}" [src]="img.path" [alt]="img.name">
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button *ngIf="selectedImage" icon="pi pi-check" (click)="uploadImage()" label="{{ 'ADD' | translate }}"
            class="add-btn-media" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="{{ 'QUESTION_TYPE' | translate }}" [(visible)]="isFormTypePopup" position="center"
    [style]="{width: '50vw'}" [modal]="true">
    <div class="row">
        <div class="col-md-3" *ngFor="let questionType of questionTypeArr">
            <div class="question-type-list">
                <div class="question-type-list-title">{{questionType.type}}</div>
                <ul>
                    <li *ngFor="let qtype of questionType.questionTypes" (click)="selectQuestionType(qtype.value)">
                        <span [ngStyle]="{backgroundColor: questionIcons[qtype.value].color}"><i
                                class="{{questionIcons[qtype.value].icon}}"></i></span>
                        <div>{{qtype.name}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</p-dialog>